import React from 'react';
import PropTypes from 'prop-types';
import { PageLayout } from '~/components/common';

const Toolbox = ({ routes }) => {
  const sideNavItems = routes.map(r => ({
    label: r.label || r.path,
    to: `/toolbox/${r.path}`,
  }));

  return (
    <PageLayout
      routes={routes}
      sideNavItems={sideNavItems}
    />
  );
};

Toolbox.propTypes = {
  routes: PropTypes.arrayOf(PropTypes.shape).isRequired,
};

export default Toolbox;
